(function mdvCollectionSearchV2(root) {
  'use strict';

  var FACET_ORDER = ['category', 'size', 'colour', 'fit', 'material', 'price', 'availability', 'sale'];
  var SORT_MAP = { manual: 'featured', 'created-descending': 'newest', 'price-ascending': 'price-asc', 'price-descending': 'price-desc', 'best-selling': 'relevance' };

  function text(value) { return String(value == null ? '' : value).normalize('NFKC').trim(); }
  function esc(value) {
    return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
  function definition(definitions, key) {
    if (Array.isArray(definitions)) return definitions.find(function find(value) { return value && (value.id === key || value.key === key); }) || null;
    return definitions && definitions[key] ? definitions[key] : null;
  }
  function exactPricing(payload) {
    return text(payload && payload.meta && payload.meta.pricingMode).toLowerCase() === 'exact';
  }
  function activeFilters() { return Object.fromEntries(FACET_ORDER.map(function entry(key) { return [key, new Set()]; })); }
  function filterPayload(filters) { return Object.fromEntries(FACET_ORDER.map(function entry(key) { return [key, Array.from(filters[key])]; })); }
  function resultKey(card) { return text(card && (card.id || card.handle || card.url)); }
  function mergeResults(current, incoming) {
    var results = new Map();
    (current || []).concat(incoming || []).forEach(function add(card) {
      var key = resultKey(card);
      if (key && !results.has(key)) results.set(key, card);
    });
    return Array.from(results.values());
  }
  function countLabel(template, total, locale, fallback) {
    var numericTotal = Number(total || 0);
    var localizedTotal = (Number.isFinite(numericTotal) ? numericTotal : 0).toLocaleString(locale);
    var source = text(template) || fallback || 'View {count} items';
    var output = source.replace(/\{count\}/g, localizedTotal);
    return output.indexOf('{count}') >= 0 ? (fallback || 'View {count} items').replace(/\{count\}/g, localizedTotal) : output;
  }
  function filterFacetKey(group) {
    if (!group || typeof group.querySelector !== 'function') return '';
    var panel = group.querySelector('.filter-option-value-main[data-sec]');
    return text(panel && panel.dataset && panel.dataset.sec).toLowerCase();
  }
  function captureFilterUi(filterContent) {
    var wrapper = filterContent && typeof filterContent.closest === 'function' ? filterContent.closest('.filter-wrapper') : null;
    var openFacets = [];
    if (filterContent && typeof filterContent.querySelectorAll === 'function') {
      filterContent.querySelectorAll('.filter-item-main.active').forEach(function opened(group) {
        var key = filterFacetKey(group);
        if (key && openFacets.indexOf(key) === -1) openFacets.push(key);
      });
    }
    var scrollTop = Number(wrapper && wrapper.scrollTop);
    return { openFacets: openFacets, scrollTop: Number.isFinite(scrollTop) ? Math.max(0, scrollTop) : 0 };
  }
  function restoreFilterUi(filterContent, state) {
    if (!filterContent || typeof filterContent.querySelectorAll !== 'function') return;
    var openFacets = new Set(state && Array.isArray(state.openFacets) ? state.openFacets : []);
    filterContent.querySelectorAll('.filter-item-main').forEach(function restore(group) {
      var panel = group.querySelector('.filter-option-value-main[data-sec]');
      var opened = openFacets.has(filterFacetKey(group));
      if (group.classList && typeof group.classList.toggle === 'function') group.classList.toggle('active', opened);
      if (panel && panel.style) panel.style.display = opened ? 'block' : '';
    });
    var wrapper = typeof filterContent.closest === 'function' ? filterContent.closest('.filter-wrapper') : null;
    var scrollTop = Number(state && state.scrollTop);
    if (wrapper) wrapper.scrollTop = Number.isFinite(scrollTop) ? Math.max(0, scrollTop) : 0;
  }
  function availabilityFacetVisible(options) {
    var available = new Set((options || []).filter(function valid(option) {
      var count = Number(option && (option.optionCount != null ? option.optionCount : option.count));
      return Number.isFinite(count) && count > 0;
    }).map(function id(option) { return text(option.id); }));
    return available.has('in_stock') && available.has('out_of_stock');
  }
  function variantId(value) { var match = String(value || '').match(/(\d+)$/); return match ? match[1] : ''; }
  function href(card) {
    var raw = text(card.url || (card.handle ? '/products/' + encodeURIComponent(card.handle) : ''));
    var url;
    try { url = new URL(raw, root.location.origin); } catch (_) { return '#'; }
    if (url.origin !== root.location.origin) return '#';
    var id = variantId(card.leadVariant && card.leadVariant.id);
    if (id) url.searchParams.set('variant', id);
    return url.pathname + url.search + url.hash;
  }
  function image(value, width) {
    var raw = text(value && (value.url || value.src || value));
    if (!raw) return '';
    try { var url = new URL(raw, root.location.origin); url.searchParams.set('width', String(width)); return url.toString(); }
    catch (_) { return raw; }
  }
  function numericProductId(value) { return variantId(value); }
  function handleToken(value) { return text(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function productHandle(value, fallback) {
    try {
      var url = new URL(text(value), root.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : text(fallback);
    } catch (_) { return text(fallback); }
  }
  function collectionPriceMarkup(variant, locale, render) {
    var price = variant && variant.price;
    var compareAt = variant && variant.compareAtPrice;
    var priceAmount = Number(price && price.amount);
    var compareAmount = Number(compareAt && compareAt.amount);
    if (!render || typeof render.formatMoney !== 'function' || !Number.isFinite(priceAmount) || !text(price && price.currencyCode)) return '';
    var onSale = Number.isFinite(compareAmount) && compareAmount > priceAmount;
    var percentage = onSale ? Math.round(((compareAmount - priceAmount) / compareAmount) * 20) * 5 : 0;
    if (percentage > 40 && percentage < 50) percentage = 50;
    return '<p class="product_price_wrap' + (onSale ? ' onsale' : '') + '"><span class="actual-price1' + (onSale ? ' onsale' : '') + '">' + esc(render.formatMoney(price, locale)) + '</span>'
      + (onSale ? '<span class="compare-price">' + esc(render.formatMoney(compareAt, locale)) + '</span>' : '')
      + (onSale && percentage > 0 ? '<span class="label_onsale">' + esc(percentage) + '% Off</span>' : '') + '</p>';
  }

  function CollectionView(filterRoot, runtimeRoot) {
    this.root = filterRoot;
    this.runtime = runtimeRoot;
    this.collectionHandle = filterRoot.dataset.mdvCollectionHandle;
    this.locale = runtimeRoot.dataset.mdvSearchLocale;
    this.copy = root.MDVSearchV2Render && root.MDVSearchV2Render.copyFor
      ? root.MDVSearchV2Render.copyFor(this.locale)
      : { inColour: 'in', viewColour: 'View {colour}', addWishlist: 'Add to wishlist', loadMore: 'Load more', of: 'of', filtersSelected: '{count} filters selected', noFilters: 'No filters selected', clearFilters: 'Clear filters', viewItems: 'View {count} items' };
    this.filters = activeFilters();
    this.sort = 'featured';
    this.cursor = null;
    this.results = [];
    this.payload = null;
    this.generation = 0;
    this.enabled = false;
    this.client = null;
    this.grid = filterRoot.closest('.main-collection-section') && filterRoot.closest('.main-collection-section').querySelector('.scroll_product');
    this.filterContent = filterRoot.querySelector('.filter-content-wrapper');
    this.nativeCards = new Map();
    this.nativeNextUrl = null;
    this.nativePagesSeen = new Set();
    this.nativeExhausted = false;
    this.cacheNativeCards(this.grid);
  }

  CollectionView.prototype.cacheNativeCards = function cacheNativeCards(container) {
    if (!container || typeof container.querySelectorAll !== 'function') return;
    container.querySelectorAll('.main-product-item[data-handle]').forEach(function cache(card) {
      var handle = handleToken(card.getAttribute('data-handle'));
      if (handle && !this.nativeCards.has(handle)) this.nativeCards.set(handle, card.outerHTML);
    }, this);
    var more = container.querySelector('.collection-load-more-button[data-href]');
    if (more && more.getAttribute('data-href')) this.nativeNextUrl = more.getAttribute('data-href');
    else if (!this.nativeNextUrl) this.nativeExhausted = true;
  };
  CollectionView.prototype.nativeUrl = function nativeUrl(value) {
    var next;
    try { next = new URL(value, root.location.href); } catch (_) { return null; }
    var current = new URL(root.location.href);
    current.searchParams.forEach(function preserve(value, key) {
      if (/^(?:_ab|_fd|_sc|preview_theme_id)$/u.test(key) && !next.searchParams.has(key)) next.searchParams.set(key, value);
    });
    Array.from(next.searchParams.keys()).forEach(function remove(key) {
      if (key === 'blank' || key === 'sort' || key === 'sort_by' || key.indexOf('filter.') === 0) next.searchParams.delete(key);
    });
    return next;
  };
  CollectionView.prototype.hydrateNativeCards = async function hydrateNativeCards(cards) {
    if (!root.fetch || !root.DOMParser || this.nativeExhausted) return;
    var wanted = new Set((cards || []).map(function handle(card) { return handleToken(card && card.handle); }).filter(Boolean));
    var missing = function missing() { return Array.from(wanted).some(function absent(handle) { return !this.nativeCards.has(handle); }, this); }.bind(this);
    var safety = 0;
    while (missing() && this.nativeNextUrl && !this.nativeExhausted && safety < 30) {
      safety += 1;
      var url = this.nativeUrl(this.nativeNextUrl);
      if (!url || this.nativePagesSeen.has(url.href)) { this.nativeExhausted = true; break; }
      this.nativePagesSeen.add(url.href);
      var response = await root.fetch(url.href, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Native collection card hydration failed (' + response.status + ').');
      var page = new root.DOMParser().parseFromString(await response.text(), 'text/html');
      var grid = page.querySelector('.main-collection-section .scroll_product');
      if (!grid) throw new Error('Native collection card hydration returned no product grid.');
      this.nativeNextUrl = null;
      this.cacheNativeCards(grid);
      if (!this.nativeNextUrl) this.nativeExhausted = true;
    }
  };
  CollectionView.prototype.nativeCardMarkup = function nativeCardMarkup(card) {
    return this.nativeCards.get(handleToken(card && card.handle)) || '';
  };

  CollectionView.prototype.init = async function init() {
    if (!this.collectionHandle || !this.grid || !this.filterContent || !root.MDVSearchApiV2) return;
    try {
      this.client = root.MDVSearchApiV2.createClientFromElement(this.runtime);
      this.readUrl();
      var payload = await this.fetch(false);
      if (!payload) return;
      if (!exactPricing(payload)) {
        // Price-free V2 remains authoritative for dedicated search pages, but
        // Shopify already rendered this collection in the buyer's local price
        // context. Do not replace that correct native catalogue markup.
        this.root.dataset.mdvV2PricingMode = 'price-free';
        return;
      }
      this.enabled = true;
      this.root.dataset.mdvV2Ready = 'true';
      this.bind();
      await this.render(payload);
    } catch (error) {
      // Native Shopify collection/filter behaviour remains untouched when the
      // shared service cannot be configured or reached.
      console.warn('[MDV collection v2] Native filters retained:', error && error.message ? error.message : error);
    }
  };

  CollectionView.prototype.readUrl = function readUrl() {
    var state = root.MDVSearchApiV2.readSearchState(root.location.href);
    FACET_ORDER.forEach(function facet(key) { this.filters[key] = new Set(state.filters[key] || []); }, this);
    var parameters = new URL(root.location.href).searchParams;
    var requested = parameters.has('sort') ? state.sort : (SORT_MAP[parameters.get('sort_by')] || 'featured');
    this.sort = ['featured', 'newest', 'price-asc', 'price-desc', 'relevance'].indexOf(requested) >= 0 ? requested : 'featured';
  };
  CollectionView.prototype.writeUrl = function writeUrl() {
    var next = root.MDVSearchApiV2.buildSearchStateUrl(root.location.href, { filters: filterPayload(this.filters), sort: this.sort });
    root.history.replaceState(Object.assign({}, root.history.state || {}, { mdvCollectionV2: true }), '', next);
  };
  CollectionView.prototype.restoreNative = function restoreNative() {
    this.enabled = false;
    var current = root.MDVSearchApiV2.readSearchState(root.location.href);
    var next = root.MDVSearchApiV2.buildSearchStateUrl(root.location.href, {
      query: current.query,
      filters: filterPayload(activeFilters()),
      sort: 'relevance',
    });
    if (next !== root.location.href && root.location && typeof root.location.replace === 'function') {
      root.location.replace(next);
      return;
    }
    if (root.location && typeof root.location.reload === 'function') root.location.reload();
  };
  CollectionView.prototype.fetch = async function fetchPage(append) {
    var generation = ++this.generation;
    var payload = await this.client.searchWithScope({
      query: '', filters: filterPayload(this.filters), limit: 48,
      cursor: append ? this.cursor : null, scope: 'collection',
      collectionHandle: this.collectionHandle, includeGender: false, sort: this.sort,
    });
    if (generation !== this.generation) return null;
    this.results = mergeResults(append ? this.results : [], payload.results || []);
    this.cursor = payload.nextCursor || null;
    this.payload = payload;
    return payload;
  };

  CollectionView.prototype.bind = function bind() {
    var self = this;
    this.root.addEventListener('change', function changed(event) {
      if (!self.enabled) return;
      var option = event.target.closest('[data-mdv-v2-collection-option]');
      if (!option) return;
      event.preventDefault(); event.stopImmediatePropagation();
      var key = option.dataset.facet;
      if (option.checked) self.filters[key].add(option.value); else self.filters[key].delete(option.value);
      self.cursor = null; self.writeUrl(); self.refresh(false);
    }, true);
    document.addEventListener('click', function clicked(event) {
      if (!self.enabled) return;
      var sort = event.target.closest('.sort_by_item');
      if (sort && self.root.closest('.main-collection-section').contains(sort)) {
        event.preventDefault(); event.stopImmediatePropagation();
        var input = sort.querySelector('input'); self.sort = SORT_MAP[input && input.value] || 'featured';
        document.querySelectorAll('.sort_by_item').forEach(function selected(label) { label.classList.toggle('selected', label === sort); });
        self.cursor = null; self.writeUrl(); self.refresh(false); return;
      }
      var run = event.target.closest('#filter-run');
      if (run && self.root.contains(run)) { event.preventDefault(); event.stopImmediatePropagation(); document.body.classList.remove('active-filter'); return; }
      var clear = event.target.closest('.filter-done');
      if (clear && self.root.contains(clear)) {
        event.preventDefault(); event.stopImmediatePropagation(); self.filters = activeFilters(); self.cursor = null; self.writeUrl(); self.refresh(false); return;
      }
      var more = event.target.closest('[data-mdv-v2-collection-more]');
      if (more && self.grid.contains(more)) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (more.disabled) return;
        more.disabled = true;
        more.setAttribute('aria-busy', 'true');
        self.refresh(true);
      }
    }, true);
    root.addEventListener('popstate', function restore() {
      self.readUrl(); self.cursor = null; self.refresh(false);
    });
    document.addEventListener('change', function buyerContextChanged(event) {
      if (!event.target.closest('[name="currencies"], [data-mdv-buyer-country]')) return;
      // Native collection markup was replaced only after an exact V2 response.
      // A full same-URL reload is the safe way to restore Shopify's native
      // controller when the newly selected context is unsupported.
      Promise.resolve().then(function validateChangedContext() {
        var previous = self.client && self.client.context;
        try {
          var next = self.client && self.client.refreshContext();
          if (previous && next && previous.country === next.country && previous.currency === next.currency && previous.locale === next.locale) return;
        } catch (_) { /* reload into native fail-closed mode */ }
        self.restoreNative();
      });
    }, true);
  };
  CollectionView.prototype.refresh = async function refresh(append) {
    var requestGeneration = this.generation + 1;
    this.root.setAttribute('aria-busy', 'true');
    try {
      var payload = await this.fetch(append);
      if (payload && exactPricing(payload)) await this.render(payload);
      else if (payload && this.enabled) this.restoreNative();
    }
    catch (error) {
      if (requestGeneration !== this.generation) return;
      console.warn('[MDV collection v2] Restoring native collection after V2 failure:', error && error.message ? error.message : error);
      // Once V2 has replaced Shopify's native markup, retaining the old grid
      // after a failed filter request would show controls and products from
      // different states. A same-URL reload fails back to the untouched native
      // collection controller; init() does not reload again if V2 is still down.
      if (this.enabled) this.restoreNative();
    }
    finally { if (requestGeneration === this.generation) this.root.removeAttribute('aria-busy'); }
  };

  CollectionView.prototype.filterMarkup = function filterMarkup(payload) {
    var facets = payload.facets || {};
    return FACET_ORDER.map(function group(key) {
      var options = facets[key] || [];
      if (!options.length) return '';
      if (key === 'availability' && !availabilityFacetVisible(options)) return '';
      var meta = definition(payload.facetDefinitions, key);
      var label = text(meta && (meta.label || meta.title)) || key;
      var items = options.map(function option(value, index) {
        var checked = this.filters[key].has(value.id);
        var disabled = Boolean(value.disabled) && !checked;
        var optionCount = Number(value.optionCount != null ? value.optionCount : value.count || 0);
        var nextResultCount = Number(value.nextResultCount != null ? value.nextResultCount : optionCount);
        var id = 'Filter-mdv-v2-' + this.collectionHandle + '-' + key + '-' + index;
        var colourClass = key === 'colour' ? ' ' + esc(value.id.replace(/[^a-z0-9]+/g, '-')) : '';
        return '<li data-show="true"' + (disabled ? ' class="disabled"' : '') + '><label for="' + esc(id) + '">'
          + '<input id="' + esc(id) + '" type="checkbox" value="' + esc(value.id) + '" data-mdv-v2-collection-option data-facet="' + esc(key) + '" data-option-count="' + esc(optionCount) + '" data-next-result-count="' + esc(nextResultCount) + '"'
          + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '><span class="fitler-square' + colourClass + '"></span>'
          + '<span>' + esc(value.label || value.id) + ' (' + optionCount.toLocaleString(this.locale) + ')</span></label></li>';
      }, this).join('');
      return '<div class="filter-item-main ' + esc(key) + (key === 'sale' ? ' filter-is-sale' : '') + '"><div class="filter-item-header"><h2>' + esc(label) + '</h2><span><svg width="16" height="9" viewBox="0 0 16 9" fill="none" aria-hidden="true"><path d="M1 1L8 8L15 1" stroke="currentColor" stroke-width="1.16667"></path></svg></span></div>'
        + '<div class="filter-option-value-main" data-sec="' + esc(key) + '"><ul class="filter-option">' + items + '</ul></div></div>';
    }, this).join('');
  };

  CollectionView.prototype.cardMarkup = function cardMarkup(card, index) {
    var render = root.MDVSearchV2Render;
    var interpolate = render && render.copyText ? render.copyText : function fallback(value, variables) {
      return Object.keys(variables || {}).reduce(function replace(output, key) { return output.replace(new RegExp('\\{' + key + '\\}', 'g'), variables[key]); }, value || '');
    };
    var productUrl = href(card);
    var picture = image(card.image || (card.images && card.images[0]), 900);
    var hoverPicture = image(card.images && card.images[1], 900);
    var pictureMarkup = picture
      ? '<div class="swiper main-product-carousel"><div class="swiper-wrapper">'
        + '<div class="swiper-slide"><div class="swiper-slide-content"><img src="' + esc(picture) + '" alt="' + esc(card.title) + '" loading="' + (index < 6 ? 'eager' : 'lazy') + '"></div></div>'
        + (hoverPicture ? '<div class="swiper-slide"><div class="swiper-slide-content"><img src="' + esc(hoverPicture) + '" alt="" class="hover-img" loading="lazy"></div></div>' : '')
        + '</div></div>'
      : '';
    var title = card.descriptor && card.colour ? card.descriptor + ' ' + this.copy.inColour + ' ' + (card.colour.label || card.colour) : (card.descriptor || card.title);
    var price = collectionPriceMarkup(card.leadVariant, this.locale, render);
    var variants = card.variantOptions || [];
    var swatches = (card.swatches || []).map(function swatch(value) {
      var colour = text(value.colour && (value.colour.label || value.colour));
      var colourId = text(value.colour && value.colour.id) || colour;
      var colourClass = handleToken(colourId);
      var colourToken = handleToken(colourId).split('-').pop() || 'transparent';
      var swatchUrl = value.url ? href({ url: value.url }) : productUrl;
      var swatchHandle = productHandle(swatchUrl, card.handle);
      var swatchImage = image(value.image, 900);
      var borderClass = /(?:white|multi|cream|ivory)/i.test(colour) ? ' borderadded' : '';
      return '<a href="' + esc(swatchUrl) + '" title="' + esc(card.title) + '" class="hide-' + esc(handleToken(swatchHandle)) + '" data-img1-src="' + esc(swatchImage) + '" data-img2-src="' + esc(swatchImage) + '" data-itemhandle="' + esc(swatchHandle) + '" aria-label="' + esc(interpolate(this.copy.viewColour, { colour: colour || '' })) + '">'
        + '<div class="swatch-element" hidethis="' + esc(swatchHandle) + '"><div style="width:20px;height:20px;background-color:' + esc(colourToken) + ';" data-value="' + esc(colour) + '" class="selected swatch-element color ' + esc(colourClass) + borderClass + '"></div></div></a>';
    }, this).join('');
    var swatchMarkup = swatches
      ? '<div class="main_colors_wrapper" data-mdv-processing="true" check-current="' + esc(card.handle) + '"><div class="product-alt-colours">' + swatches + '</div></div>'
      : '';
    var swatchHover = swatchMarkup ? '<div class="product-hover">' + swatchMarkup + '</div>' : '';
    var sizes = variants.length ? '<div class="product-size-box"><ul>' + variants.map(function variant(value) {
      var id = variantId(value.id); var size = value.size && (value.size.label || value.size.id) || '';
      return '<li' + (value.available ? '' : ' class="size-sold"') + '><a href="' + esc(productUrl.split('?')[0] + (id ? '?variant=' + encodeURIComponent(id) : '')) + '">' + esc(size) + '</a></li>';
    }).join('') + '</ul></div>' : '';
    return '<div class="main-product-item color-square-item" data-handle="' + esc(card.handle) + '"><div class="main-product-wrp">'
      + '<div class="sizing-deta"><a href="' + esc(productUrl) + '" class="main-product-inner color-square-item-href"><div class="main-product-image color-square-item-image-main">'
      + pictureMarkup + '</div></a>' + sizes + '</div>'
      + '<div class="main-product-content"><div class="main-product-title-row"><div class="main-product-title' + (card.creative ? ' new-collection-product-title' : '') + '">'
      + (card.creative ? '<div class="product-card-redesign"><h5><span class="text-unset">' + esc(card.creative) + '</span></h5>' + swatchHover + '</div>' : swatchHover)
      + '<a href="' + esc(productUrl) + '"><h5 class="text-unset">' + esc(title) + '</h5></a></div>'
      + '<div class="cs_ws_icon" data-id="' + esc(numericProductId(card.id)) + '" data-handle="' + esc(card.handle) + '" data-varId="' + esc(variantId(card.leadVariant && card.leadVariant.id)) + '"><button aria-label="' + esc(this.copy.addWishlist) + '" id="ws-fav-btn" type="button" class="action_button"><span class="cs-wishlist-icon"><svg width="25" height="21" viewBox="0 0 23 21" fill="none" aria-hidden="true"><path d="M11.58.99l3.09 6.26 6.91 1.01-5 4.87 1.19 6.89-6.19-3.26-6.19 3.26 1.19-6.89-5-4.87 6.91-1.01L11.58.99Z" stroke="currentColor" stroke-width="1.5"></path></svg></span></button></div></div>'
      + '<div class="main-product-price">' + price + '</div></div></div></div>';
  };

  CollectionView.prototype.render = async function render(payload) {
    if (!exactPricing(payload)) return;
    var generation = this.generation;
    await this.hydrateNativeCards(this.results);
    if (generation !== this.generation) return;
    var render = root.MDVSearchV2Render;
    var interpolate = render && render.copyText ? render.copyText : function fallback(value, variables) {
      return Object.keys(variables || {}).reduce(function replace(output, key) { return output.replace(new RegExp('\\{' + key + '\\}', 'g'), variables[key]); }, value || '');
    };
    var filterUi = captureFilterUi(this.filterContent);
    this.filterContent.innerHTML = this.filterMarkup(payload);
    restoreFilterUi(this.filterContent, filterUi);
    this.grid.innerHTML = this.results.map(function card(value, index) {
      return this.nativeCardMarkup(value) || this.cardMarkup(value, index);
    }, this).join('')
      + (this.cursor ? '<div class="mdv-collection-v2__load-more"><button class="mdv-collection-v2__load-more-button" data-mdv-v2-collection-more>' + esc(this.copy.loadMore) + ' <span>|</span> ' + this.results.length.toLocaleString(this.locale) + ' ' + esc(this.copy.of) + ' ' + Number(payload.total || 0).toLocaleString(this.locale) + '</button></div>' : '');
    var selected = FACET_ORDER.reduce(function total(count, key) { return count + this.filters[key].size; }.bind(this), 0);
    var selectedLabel = this.root.querySelector('.filter-selected');
    if (selectedLabel) selectedLabel.textContent = selected ? interpolate(this.copy.filtersSelected, { count: selected.toLocaleString(this.locale) }) : this.copy.noFilters;
    var clear = this.root.querySelector('.filter-done'); if (clear) clear.textContent = selected ? this.copy.clearFilters : '';
    var bottom = this.root.querySelector('.bottom-btn');
    if (bottom) bottom.textContent = countLabel(this.copy.viewItems, payload.total, this.locale, 'View {count} items');
    var headingCount = root.document.querySelector('.tabbing-collection-count');
    if (headingCount) headingCount.textContent = Number(payload.total || 0).toLocaleString(this.locale) + ' Items';
    this.root.dataset.mdvV2Total = String(Number(payload.total || 0));
    if (typeof root.loadedAllTime === 'function') root.loadedAllTime();
    if (typeof root.loadSwatches === 'function') root.loadSwatches();
    if (typeof root.initializeSwiperForMobile === 'function') root.initializeSwiperForMobile();
    if (typeof root.CSWishlistrefreshData === 'function') root.CSWishlistrefreshData();
  };

  function start() {
    var runtime = document.querySelector('[data-mdv-search][data-mdv-search-api-url]');
    if (!runtime) return;
    document.querySelectorAll('[data-mdv-collection-filter]').forEach(function each(filterRoot) {
      var view = new CollectionView(filterRoot, runtime); filterRoot.mdvCollectionV2 = view; view.init();
    });
  }
  if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
  var publicApi = {
    FACET_ORDER: FACET_ORDER.slice(),
    CollectionView: CollectionView,
    activeFilters: activeFilters,
    filterPayload: filterPayload,
    mergeResults: mergeResults,
    countLabel: countLabel,
    captureFilterUi: captureFilterUi,
    restoreFilterUi: restoreFilterUi,
    availabilityFacetVisible: availabilityFacetVisible,
    collectionPriceMarkup: collectionPriceMarkup,
  };
  root.MDVCollectionSearchV2 = publicApi;
  if (typeof module === 'object' && module && module.exports) module.exports = publicApi;
}(typeof globalThis !== 'undefined' ? globalThis : this));
